import { createSlice } from "@reduxjs/toolkit";

const accountingSlice = createSlice({
  name: "accountTypes",
  initialState: {
    types: {},
    subTypes: {},
  },

  reducers: {
    setAccountTypes: (state, action) => {
      state.types = action.payload.types;
    },
    setAccountSubTypes: (state, action) => {
      state.subTypes = action.payload.subTypes;
    },
  },
});

export const { setAccountTypes, setAccountSubTypes } = accountingSlice.actions;

export default accountingSlice.reducer;
